<template>
    <a-table>
        <div class="table-wrapper">
            <vuetable v-bind="attributes" ref="users-vuetable">
                <div  slot="checkbox" slot-scope="props" v-on:click.stop>
                    <Input type="checkbox"  v-on:input="updateSelectedItems" v-model="props.rowData.selected"></Input>
                </div>
                <div  slot="avatar" slot-scope="props">
                    <avatar :name="parseName(props.rowData.user)"></avatar>
                </div>
                <div  slot="name" slot-scope="props">
                    {{parseName(props.rowData.user)}}
                </div>
                <div  slot="role" slot-scope="props">
                    <Label>{{props.rowData.role}}</Label>
                </div>
                <div  slot="groups" slot-scope="props">
                    <Label v-bind:key="group.uuid" v-for="group in props.rowData.groups">{{group.name}}</Label>
                </div>
                <div v-if="includeActions"  slot="actions" slot-scope="props">
                    <action-buttons :links="props.rowData._links" @action="openModal($event, props.rowData)"></action-buttons>
                </div>
            </vuetable>
            <placeholder-table v-if="isLoading"></placeholder-table>
        </div>
        <vuetable-pagination ref="users-pagination"></vuetable-pagination>
        <div class="card-bottom-actions" v-if="includeActions">
            <!--<Button :disabled="selectedItems.length===0" variant="neutral"  @click.native="editingUsersModal" class="float-left">
                <svgicon name="edit"></svgicon>
                Edit {{selectedItems.length}} selected
            </Button>-->
            <Button :disabled="selectedItems.length===0" variant="danger" @click.native="deletingUsersModal" class="float-left">
                <svgicon name="delete"></svgicon>
                Delete {{selectedItems.length}} selected
            </Button>
            <Button @click.native="openInviteModal()" class="float-right">
                <svgicon name="plus"></svgicon>
                Invite user(s)
            </Button>
        </div>
        <Modal v-if="modal.update === true" @close="modal.update = false" size="md" id="edit-modal">
            <h4 class="modal-title">Edit user</h4>
            <p>You can change the selected users' roles and groups below. To edit an individual user, click on the edit icon in the user overview table.</p>
            <div class="input input-inline">
            <label>Role</label>
            <select v-model="selectedUsers[0].role">
                <option value="member">Member</option>
                <option value="admin">Admin</option>
            </select>
            </div>
            <div class="input input-expand">
                <label>Groups</label>
                <multi-select-search :fetch="_getGroups" v-model="selectedUsers[0].groups"></multi-select-search>
            </div>
            <template v-slot:modal-actions>
                <Button variant="default" @click.native="applyAction('update', selectedUsers)" class="float-right">Edit {{selectedUserStr}}</Button>
            </template>
        </Modal>
        <Modal v-if="modal.delete === true" @close="modal.delete = false" size="md" id="delete-modal">
            <h4 class="modal-title">Delete user</h4>
            <p>Are you sure you want to delete {{selectedUserStr}}? This cannot be undone.</p>
            <template v-slot:modal-actions>
                <Button variant="danger" @click.native="applyAction('delete', selectedUsers)" class="float-right">Delete {{selectedUserStr}}</Button>
            </template>
        </Modal>
        <invite-modal :show="modal.invite === true" @created="$emit('invite:created')" @close="modal.invite = false"></invite-modal>
    </a-table>
</template>
<script>
    import tableStyling from '../../../utils/tableStyling'
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
    import api from '../../../api'
    import Avatar from "../../Avatar/Avatar";
    import Label from "../../Label/Label";
    import Input from "../../Input/Input";
    import Button from "../../Button/Button";
    import Modal from "../../Modal/Modal";
    import InviteModal from "../../InviteModal/InviteModal";
    import tableMixin from "../tableMixin";
    import {mapActions, mapState} from "vuex";
    import ActionButtons from "../../ActionButtons/ActionButtons";
    import ATable from "../ATable";
    import MultiSelectSearch from "../../MultiSelectSearch/MultiSelectSearch";
    import {_applyAction} from "../../../utils/actions";
    import PlaceholderTable from "../PlaceholderTable/PlaceholderTable";

    export default {
        name: 'UsersTable',
        components: {
            PlaceholderTable,
            MultiSelectSearch,
            ATable,
            ActionButtons,
            InviteModal,
            Modal,
            Button,
            Input,
            Label,
            Avatar,
            Vuetable,
            VuetablePagination
        },
        mixins: [tableMixin],
        data () {
            return {
                model: 'users',
                css: tableStyling,
                fields: [
                    {
                        name:'checkbox',
                        title: '<div class="input checkbox-input">' +
                            '        <label class="checkbox">' +
                            '            <input id="checkAll-users" type="checkbox"/>' +
                            '            <span class="checkmark"></span>' +
                            '        </label>' +
                            '    </div>',
                    },
                    {
                        name:'avatar',
                        title: ''
                    }, {
                        name:'name',
                        title: 'Name',
                    }, {
                        name: "role",
                        title: 'Roles',
                    }, {
                        name: "groups",
                        title: "Groups"
                    }, {
                        name: "themes",
                        title: "Themes"
                    },
                ],
                modal: {
                    update: false,
                    delete: false
                },
                selectedUsers: [],
                selectedUser: {},
            }
        },
        computed: {
            ...mapState({
                team: state => state.team,
            }),
            selectedUserStr(){
                console.log(this.selectedUsers);
                if(this.selectedUsers.length===1){
                    return this.parseName(this.selectedUsers[0].user);
                }
                return this.selectedUsers.length+' users';
            },
            ...mapState({
                groups: state => state.groups.all,
            }),
        },
        mounted () {},
        methods: {
            ...mapActions('users', [
                '_getActiveUsers',
                '_updateUser',
                '_deleteUsers'
            ]),
            ...mapActions('groups', [
                '_getGroups',
            ]),
            fetchUsers(url, options){
                options.params.include = "user,groups,role";
                options.params.forceUpdate = true;
                return this._getActiveUsers({query: options.params});
            },
            parseName(user){
                return user.first_name + " " + user.last_name;
            },
            deletingUsersModal(){
                this.selectedUsers = this.selectedItems;
                this.modal.delete = true;
            },
            openModal(action, data){
                console.log(data);
                this.selectedUsers = [data];
                this.modal[action] = true;
            },
            openInviteModal(){
                console.log("hallo");
                this.modal.invite = true;
            }
        }
    }

</script>

